import React from 'react';
import { Box, Typography } from '@mui/material';

export const FieldStatus = ({ hectaresToAdd, LangFile }) => {
  return (
    <Box
      sx={{
        fontWeight: 300,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {LangFile.PolygonDrawing.selectedHectares}
        <Typography variant="body2">{hectaresToAdd} ha</Typography>
      </Box>
    </Box>
  );
};
